<div
  class="search-container"
  appClickOutside
  (appClickOutside)="onClickOutside()"
  [class.roll-out]="isSearchActive()"
  [class.roll-out]="isMobileView()"
  [class.d-none]="isMobileSearchActive()"
  [class.search-container-t2]="theme() === GbTheme.ThemeTwo"
>
  <input
    class="primary-font-medium search-input"
    type="text"
    [placeholder]="placeholder()"
    [class.active]="isSearchActive()"
    [class.active]="isMobileView()"
    [value]="searchValue()"
    (input)="handleSearchInput($event)"
  />
  <button
    class="primary-button rounded-pill search-button flex-center"
    (click)="toggleSearch()"
    [class.search-button-t2]="theme() === GbTheme.ThemeTwo"
  >
    <svg
      class="rtl"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.0297 15.0258L19.0527 19.0488M0.949219 8.99129C0.949219 11.1252 1.79692 13.1717 3.30583 14.6807C4.81474 16.1896 6.86127 17.0373 8.9952 17.0373C11.1291 17.0373 13.1756 16.1896 14.6846 14.6807C16.1935 13.1717 17.0412 11.1252 17.0412 8.99129C17.0412 6.85736 16.1935 4.81084 14.6846 3.30192C13.1756 1.79301 11.1291 0.945313 8.9952 0.945312C6.86127 0.945313 4.81474 1.79301 3.30583 3.30192C1.79692 4.81084 0.949219 6.85736 0.949219 8.99129Z"
        stroke="white"
        stroke-width="1.72414"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
  <div class="search-dropdown" [class.show]="isDropdownOpen()">
    <div class="destination-list-container">
      <ul class="destination-list">
        @for (item of filteredSearchResults(); track item._id) {
          <li>
            <button class="primary-font-medium w-100 default-button" (click)="selectItem(item)">
              @if (item.regionType === 'country') {
                {{ 'country_names.' + getCountryIso3code(item) | translate }}
              } @else {
                {{ 'region_names.' + item.slug | translate }}
              }
            </button>
          </li>
        } @empty {
          <li>
            <p class="primary-font-medium mb-0">
              {{ 'buy_plan.plan_list.destination_search.no_results_found' | translate }}
            </p>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
